import React from 'react';
import { checkPixel } from 'utils';
import * as Icons from 'assets/icons';
import styled from 'styled-components';

export function Icon({ name, onClick, ...props }) {
  const IconComponent = Icons[name];

  if (!IconComponent) {
    return null;
  }

  // Check if the IconComponent is an image URL (for GIFs) or an SVG component
  const isImageUrl = typeof IconComponent === 'string';


  return (
    <Container {...props} onClick={onClick}>
      {isImageUrl ? (
        <img src={IconComponent} className="icon" alt={name} />
      ) : (
        <IconComponent className="icon" />
      )}
    </Container>
  );
}

const Container = styled.span`
  display: inline-block;
  line-height: 0;
  transition: opacity 150ms ease;
  ${({ $padding }) => $padding && `padding:${$padding}`};
  ${({ $transform }) => $transform && `transform:${$transform}`};
  ${({ $visibility }) => $visibility && `visibility:${$visibility}`};

  .icon {
    ${({ $width }) => $width && `width:${checkPixel($width)}`};
    ${({ $height }) => $height && `height:${checkPixel($height)}`};
    ${({ $fill, theme }) => $fill && `fill:${theme.colors[$fill] || $fill}`};
    ${({ $stroke, theme }) => $stroke && `stroke:${theme.colors[$stroke] || $stroke}`};
    & path {
      ${({ $pathFill, theme }) => $pathFill && `fill:${theme.colors[$pathFill] || $pathFill}`};
      ${({ $pathStroke, theme }) => $pathStroke && `stroke:${theme.colors[$pathStroke] || $pathStroke}`};
    }
    & rect {
      ${({ $rectFill, theme }) => $rectFill && `fill:${theme.colors[$rectFill] || $rectFill}`};
    }
  }
`;
